export const getStagedFilteredResultsCtaText = (
	stagedResultsCount: number | undefined,
) =>
	!stagedResultsCount ? 'No results' : `See Results (${stagedResultsCount})`;
